import { useState, useEffect } from "react";
import { LEAD_USER_KEY } from "../components/common/constant";

export const useLeadUser = () => {
  const [value, setValue] = useState(() => {
    const storedValue = localStorage.getItem(LEAD_USER_KEY);
    return storedValue ? JSON.parse(storedValue) : undefined;
  });

  useEffect(() => {
    const handleStorageChange = () => {
      const storedValue = localStorage.getItem(LEAD_USER_KEY);
      setValue(storedValue ? JSON.parse(storedValue) : undefined);
    };

    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  return [value];
};
